import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "overlay center" }
const _hoisted_2 = { class: "rectangle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "rectangle__border1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "rectangle__border2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "rectangle__border3" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "rectangle__border4" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "overlay bottom" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "overlay right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "ui-crop-image noselect",
    style: _normalizeStyle([_ctx.backgroundStyle, { 'max-width': _ctx.maxWidth + 'px' }])
  }, [
    _createElementVNode("div", {
      class: "overlay left",
      style: _normalizeStyle(_ctx.leftStyle)
    }, null, 4),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "top",
        style: _normalizeStyle(_ctx.topStyle)
      }, null, 4),
      _createElementVNode("div", {
        class: "frame",
        style: _normalizeStyle(_ctx.frameStyle),
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onMouseDown($event)))
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controls, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: _normalizeClass([_ctx.getClassForControlType(item), "btn"]),
                onMousedown: _withModifiers(($event: any) => (_ctx.onMouseDown($event, item)), ["stop"])
              }, null, 42, _hoisted_8))
            }), 128))
          ])
        ])
      ], 36),
      _hoisted_9
    ]),
    _hoisted_10
  ], 4))
}